import { useAtom } from 'jotai';

import {
  modalValidateAtom,
  modalValidateDataAtom,
} from '@/src/modules/CampaignsModule/components/HtmlUpload/atoms/modalValidateAtom';

export const useModalValidate = () => {
  const [isOpen, setIsOpen] = useAtom(modalValidateAtom);
  const [data, setData] = useAtom(modalValidateDataAtom);

  return { isOpen, data, setIsOpen, setData };
};
